import { gql, useMutation } from '@apollo/client';
import { USER_FIELDS, User } from './useUserQuery';

const CONFIRM_USER = gql`
  ${USER_FIELDS}
  mutation ConfirmUser($token: String!) {
    confirmUser(token: $token) {
      ...UserFields
      token
    }
  }
`;

export interface ConfirmUserResult {
  confirmUser: User;
}

export interface ConfirmUserInput {
  token: string;
}

export function useUserConfirmMutation() {
  return useMutation<ConfirmUserResult, ConfirmUserInput>(CONFIRM_USER, {
    fetchPolicy: 'no-cache',
    refetchQueries: ['GetUser'],
    // update the user in the cache upon confirmation
    update(cache, { data }) {
      if (data?.confirmUser) {
        cache.writeFragment({
          id: cache.identify({ __typename: 'User', id: data.confirmUser.id }),
          fragment: gql`
            fragment ConfirmedUser on User {
              id
              confirmed
              mailSent
              token
            }
          `,
          data: {
            id: data.confirmUser.id,
            confirmed: data.confirmUser.confirmed,
            mailSent: data.confirmUser.mailSent,
            token: data.confirmUser.token,
          },
        });
      }
    },
  });
}
